import React from 'react';
import { Button, notification } from "antd";
import moment from 'moment';
import i18next from "i18next";
import { LoadingOutlined } from "@ant-design/icons";
import { takeEvery, put, select, call } from "redux-saga/effects";
import { types } from "../reducers/notifications";
import { useSelector } from "react-redux";

const MINUTES_BEFORE_DELETE = 1;

const PublishNotification = ({ id }) => {
  const notifications = useSelector((state) => state.notifications);
  const _notification = notifications.find((n) => n.id === id);
  if (_notification && _notification.published) {
    return (
      <div>
        {`${i18next.t('Published')} ${_notification.published} ${_notification.published === 1 ? 'item' : 'items'} ${i18next.t('successfully')}`}
      </div>
    )
  }
  return (
    <div>
      {i18next.t('Publication started')}
    </div>
  );
}

function* initNotifications() {
  const sessionNotifications = localStorage.getItem('notifications');
  if (sessionNotifications) {
    let arr = JSON.parse(sessionNotifications);
    if (Array.isArray(arr)) {
      arr = arr.filter((s) => {
        if (s.started) {
          const minutes = moment.duration(moment().diff(moment(s.started))).asMinutes();
          if (minutes < MINUTES_BEFORE_DELETE) {
            return true;
          }
        }
        return false;
      });
      yield put({
        type: types.SET_NOTIFICATIONS,
        value: arr,
      });
    }
  }
  notification.config({
    placement: 'bottomLeft',
  });
}

export default function* saga() {
  yield call(initNotifications);
  yield takeEvery(
    types.ADD_NOTIFICATION,
    addNotification,
  );
  yield takeEvery(
    types.REMOVE_NOTIFICATION,
    removeNotification,
  );
}

const getName = (namespace) => {
  switch (namespace) {
    case 'Stakeholder':
      return i18next.t('Stakeholder');
    case 'SCL':
      return i18next.t('Loaction');
    default:
      return '';
  }
}

const startNotification = ({ data, prevData, api }) => {
  return;
  const { namespace } = data;

  if (prevData && notification) {
    notification.destroy(prevData.id);
  }

  if (data.status === 'started') {
    if (data.namespace === 'Publication') {
      api.open({
        message: i18next.t('Publication'),
        description: <PublishNotification id={data.id} />,
        duration: null,
        icon: <LoadingOutlined style={{ color: 'var(--mmt-primary-60)' }} />,
        btn: (
          <Button type="link" size="small" onClick={() => notification.destroy(data.id)}>
            {i18next.t('Dismiss')}
          </Button>
        ),
        key: data.id,
      });
    }
  }

  if (data.status === 'success') {
    if (data.namespace === 'Publication') {
      api.success({
        message: i18next.t('Publication'),
        description: `${i18next.t('Published')} ${data.published} ${data.published === 1 ? 'item' : 'items'} ${i18next.t('successfully')}`,
      });
    }
  }

  if (data.status === 'fail') {
    if (data.title) {
      api.error({
        message: i18next.t('Error'),
        description: i18next.t(data.title),
      });
    } else if (data.namespace === 'Publication') {
      api.error({
        message: i18next.t('Publication'),
        description: i18next.t('Publication failed'),
      });
    }
  }
};

function* addNotification({ value: { data, api } }) {
  try {
    const notifications = yield select((state) => state.notifications);
    if (data.status === 'progress') {
      const noti = notifications.find((n) => n.id === data.id);
      if (noti) {
        const _newNoti = notifications.map((n) => {
          if (n.id === data.id) {
            return { ...n, published: data.published };
          }
          return n
        });

        localStorage.setItem('notifications', JSON.stringify(_newNoti));
        yield put({
          type: types.SET_NOTIFICATIONS,
          value: _newNoti,
        });
      }

      return;
    }
    let value = [];
    data.started = Date.now();
    const prevNot = notifications.find((n) =>
      n.id === data.id && n.status === 'started');

    if (prevNot) {
      startNotification({ data, prevData: prevNot, api });
      value = [
        ...notifications.filter((d) => d.id !== prevNot.id),
        { ...prevNot, ...data },
      ];
      yield put({
        type: types.SET_NOTIFICATIONS,
        value,
      });
    } else {
      startNotification({ data, api });
      value = [
        ...notifications,
        data,
      ];
      yield put({
        type: types.SET_NOTIFICATIONS,
        value: value,
      });
    }
    localStorage.setItem('notifications', JSON.stringify(value));
  } catch (err) {
    console.log(err);
  }
}

function* removeNotification({ value: { data } }) {
  const notifications = yield select((state) => state.notifications);
  try {
    if (data.id) {
      const value = [...notifications.filter((n) => n.id !== data.id)];
      yield put({
        type: types.SET_NOTIFICATIONS,
        value: value,
      });
      localStorage.setItem('notifications', JSON.stringify(value));
      return;
    }
    throw new Error('Id not found');
  } catch (err) {
    console.log(err);
  }
}
